module.exports = __webpack_public_path__ + "img/top_effect.219f8bcc.jpg";